import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import {  Store } from '@ngrx/store';
import { PopoverService } from 'app/core/services/popover.service';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

let id = 1;

@Component({
  selector: 'app-auctions-popover',
  templateUrl: './auctions-popover.component.html',
  styleUrls: ['./auctions-popover.component.scss']
})

export class AuctionsPopoverComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() auction:any = null
  @Input() btnText:any = null

  public isProduction = false;

  private _id = id++;
  get id() {
    return `AuctionsPopoverEvent_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
    public auctionManageService:AuctionManageService,
    public store: Store,
  ) {

    this.isProduction = window['isProduction'];
   }

  ngOnInit(): void {
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  onDownloadBidders(){
    this.auctionManageService.getAuction(this.auction.id)
      .pipe(      
        takeUntilDestroyed(this.destroyRef))
      .subscribe((auction: any) => {
        const notDeletedItems = auction.campaignTypeData.presetOptions.filter(auctionItem => auctionItem.status !== 1)
        auction.campaignTypeData.presetOptions = notDeletedItems;

        this.auctionManageService.onDownloadBidders(auction)
      })
  }

  onDownloadBidSheet(){
    this.auctionManageService.onDownloadBidSheet(this.auction)
  }

  onDownloadBidSheetQrt(){
    this.auctionManageService.onDownloadBidSheetQrt(this.auction)
  }
  
  downloadBidSheetQrX4(){
    this.auctionManageService.downloadBidSheetQrX4(this.auction)
  }
}
